import ajaxService from './ajaxService';

export default {
  // 取得多筆商品詳情
  getProducts(body) {
    return ajaxService.post('/pdi/post/api/v1/product-info-list-query', body);
  },
  // 取得兌禮商品列表
  getRedeemItems(body) {
    return ajaxService.post('/pdi/post/api/v1/redeem/items', body, {});
  },
  // 取得兌禮商品分類列表
  getRedeemItemDepts(param) {
    const queryString = new URLSearchParams(param).toString();
    return ajaxService.post(`/pdi/get/api/v1/redeem/dept?${queryString}`);
  },
  // 取得多筆歷史兌禮商品
  getRedeemItemsHistory(body) {
    return ajaxService.post('/pdi/post/api/v1/redeem/items/history', body, {});
  },
};
